document.querySelectorAll('.hc').forEach(function (root) {
  var catBtns     = Array.from(root.querySelectorAll('.hc__cat'));
  var panels      = Array.from(root.querySelectorAll('.hc__panel:not(.hc__panel--search)'));
  var searchInput = root.querySelector('.hc__search-input');
  var searchWrap  = root.querySelector('.hc__search-wrap');
  var searchBtn   = root.querySelector('.hc__search-btn');
  var searchPanel = root.querySelector('.hc__panel--search');
  var resultsList = searchPanel ? searchPanel.querySelector('.hc__search-results-list') : null;
  var noResults   = searchPanel ? searchPanel.querySelector('.hc__no-results') : null;
  var activeHandle = catBtns.length ? catBtns[0].dataset.handle : '';

  var allItems = [];
  panels.forEach(function (panel) {
    panel.querySelectorAll('.accordion').forEach(function (acc) {
      allItems.push({
        handle:  panel.dataset.handle || '',
        title:   acc.dataset.hcTitle  || '',
        content: acc.dataset.hcContent || '',
        el:      acc
      });
    });
  });

  function showCategory(handle) {
    activeHandle = handle;
    catBtns.forEach(function (btn) {
      var on = btn.dataset.handle === handle;
      btn.classList.toggle('hc__cat--active', on);
      btn.setAttribute('aria-selected', String(on));
    });
    panels.forEach(function (p) {
      var on = p.dataset.handle === handle;
      p.classList.toggle('hc__panel--active', on);
      p.hidden = !on;
    });
    if (searchPanel) searchPanel.hidden = true;
  }

  function updateSearchButton(raw) {
    var hasValue = Boolean(raw.trim());
    if (searchWrap) searchWrap.classList.toggle('hc__search-wrap--has-value', hasValue);
    if (searchBtn) {
      searchBtn.setAttribute('aria-label', hasValue ? 'Zoekopdracht wissen' : 'Zoeken');
    }
  }

  catBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      updateSearchButton('');
      showCategory(btn.dataset.handle);
    });
  });

  function doSearch(raw) {
    updateSearchButton(raw);
    var q = raw.trim().toLowerCase();
    if (!q) {
      showCategory(activeHandle);
      return;
    }
    catBtns.forEach(function (b) {
      b.classList.remove('hc__cat--active');
      b.setAttribute('aria-selected', 'false');
    });
    panels.forEach(function (p) { p.hidden = true; });
    if (searchPanel) searchPanel.hidden = false;

    var matched = allItems.filter(function (item) {
      return item.title.indexOf(q) !== -1 || item.content.indexOf(q) !== -1;
    });

    resultsList.innerHTML = '';
    noResults.hidden = matched.length > 0;
    matched.forEach(function (item) {
      var clone = item.el.cloneNode(true);
      clone.removeAttribute('open');
      resultsList.appendChild(clone);
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () { doSearch(searchInput.value); });
  }

  if (searchBtn && searchInput) {
    searchBtn.addEventListener('click', function () {
      if (!searchInput.value.trim()) return;
      searchInput.value = '';
      doSearch('');
      searchInput.focus();
    });
  }
});
